import { useLocation } from 'react-router-dom';

// Mirrors next/navigation's usePathname() — returns the current pathname only.
export function usePathname() {
  const { pathname } = useLocation();
  return pathname;
}
